module.exports = __webpack_public_path__ + "img/bank-kuveyt.eb3dce95.svg";